function PlaceholderCell() {
  return (
    <svg className="border-solid border border-[#CCCCCC] h-[64px] w-full cursor-not-allowed" viewBox="0 0 173 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" height="63" rx="1.5" fill="white" stroke="#CCCCCC"/>
        <line x1="1.17285" y1="0.530828" x2="172.173" y2="63.5308" stroke="#CCCCCC"/>
        <line x1="0.835198" y1="61.5279" x2="169.835" y2="2.52794" stroke="#CCCCCC"/>
    </svg>
  )
}

export default PlaceholderCell